<script>
export default {
    components: {},
    props: {
        series_data: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            required: true,
        },
        graphColor: {
            type: String,
            default: "#556ee6", // color default
        },
        total_año_anterior: {
            type: Number,
            default: 1655000000,
        },
        totalVentasMesAnterior: {
            type: Number,
            default: 1655000000,
        },
        series_x: {
            type: Array,
            default: () => [],
        },
        tipo_dato: {
            type: String,
            default: "moneda",
        },
    },
    data() {
        return {
            titulo:this.title,
            selection: "all",
            este_mes:null,
            este_año:null,
            este_año2:null,
            año_anterior:this.total_año_anterior,
            chart:{},
            chartData: {
                series:[...this.series_data],
                chartoptions: {
                    chart: {
                        height: 350,
                        type: "area",
                        toolbar: {
                            show: false,
                        },
                    },
                    colors: [this.graphColor, "#f1b44c"],
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',  // Set font size to 10px
                        },
                    },
                    stroke: {
                        curve: "smooth",
                        width: 2,
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [20, 100, 100, 100],
                        },
                    },
                    xaxis: {
                        categories: this.series_x,
                    },
                    markers: {
                        size: 1,
                        strokeWidth: 3,
                        hover: {
                            size: 4,
                            sizeOffset: 2,
                        },
                    },
                    legend: {
                        position: "top",
                        horizontalAlign: "left",

                    },
                    yaxis: {
                    labels: {
                        show: true,
                        align: 'right',
                        minWidth: 0,
                        maxWidth: 300,
                        style: {
                            colors: [],
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            cssClass: 'apexcharts-yaxis-label',
                        },
                        offsetX: -17,
                        offsetY: 0,
                        rotate: 0,
                        /* formatter: function (value) {
                            return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value)
                        } */

                    }
                },
                },
            },
        };
    },
    computed: {
    count() {
        if(this.series_x.includes("Enero")){
            return this.este_año;
        }
    },
    indicatorClass() {
        return this.variation > 0 ? 'mdi mdi-chevron-up ml-1 text-success' : this.variation < 0 ? 'mdi mdi-chevron-down ml-1 text-danger' : 'mdi mdi-minus ml-1 text-warning';
    },
    badgeClass() {
        return this.variation > 0 ? 'badge-soft-success font-size-12' : this.variation < 0 ? 'badge-soft-danger font-size-12' : 'badge-soft-warning font-size-12';
    },
    variation() {
        if(this.series_x.includes("Enero")){
            return this.año_anterior ? ((this.este_año - this.año_anterior) / this.año_anterior) * 100 : 0;
        }else{
            return this.año_anterior ? (((this.este_año) - this.año_anterior) / this.año_anterior) * 100 : 0;
        }
    },
    percentageVariation() {
        return `${this.variation.toFixed(2)}%`;
    },
    },
    methods: {
        updateData: function (timeline) {

            this.selection = timeline;
            let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            const date = new Date();
            let currentMonth = date.getMonth() +1;
            let start = 0;
            this.este_mes = this.series_data.map(series => series.data[currentMonth-1]);
            if(this.series_x.includes("Enero")){
                this.este_año = this.series_data.map(series => series.data.reduce((a, b) => a + b, 0));
            }else{

                let acum = this.series_data.map(series => series.data.reduce((a, b) => a + b, 0))
                this.este_año = acum[0]/12
                this.este_año2 = acum[1]/12
            }
            if(this.series_x.includes("Enero")){
                switch (timeline) {
                    case "three_month":
                        start = currentMonth - 3 < 0 ? 0 : currentMonth - 3;
                        break;
                    case "six_months":
                        start = currentMonth - 6 < 0 ? 0 : currentMonth - 6;
                        break;
                    case "one_year":
                        start = 0;
                        currentMonth = 12
                        break;
                    case "all":
                        start = 0;
                        currentMonth = 12
                        break;
                    default:
                }
    
                this.chartData.series = this.series_data.map(series => ({
                    name: series.name,
                    data: series.data.slice(start, currentMonth ),
                }));
                if (this.$refs.chart) {
                    this.$refs.chart.updateOptions({
                        xaxis: {
                            categories: months.slice(start, currentMonth),
                        },
                    }, true, true, true);
                }
            }else{
                let currentYear = date.getFullYear();
                let startYearIndex = 0; // Index inicial para la serie de años

                switch (timeline) {
                    case "three_year": // Cambiaremos esto a 3 años en lugar de 3 meses
                        startYearIndex = this.series_x.indexOf((currentYear - 3).toString());
                        if (startYearIndex === -1) startYearIndex = 0;
                        break;
                    case "six_year": // Cambiaremos esto a 6 años
                        startYearIndex = this.series_x.indexOf((currentYear - 6).toString());
                        if (startYearIndex === -1) startYearIndex = 0;
                        break;
                    case "one_year": // Esto sería solo el año actual
                        startYearIndex = this.series_x.indexOf(currentYear.toString());
                        if (startYearIndex === -1) startYearIndex = this.series_x.length - 1;
                        break;
                    case "all": 
                        startYearIndex = 0;
                        break;
                    default:
                }

                this.chartData.series = this.series_data.map(series => ({
                    name: series.name,
                    data: series.data.slice(startYearIndex),
                }));
                if (this.$refs.chart) {
                    this.$refs.chart.updateOptions({
                        xaxis: {
                            categories: this.series_x.slice(startYearIndex),
                        },
                    }, true, true, true);
                }
            }
        },
        formatNumber: function (num) {
            if(this.tipo_dato=="moneda"){
                return num ? num.toLocaleString("es-CL", {style: "currency", currency: "CLP"}) : null;
            }else{
                return Math.round(num)
            }
        },
    },
    created() {
        this.updateData(this.selection);
    },
    mounted() {
    },
};
</script>


<template>
    <div class="card">
            <div class="card-body">
            <div class="d-sm-flex flex-wrap">
                <h5 class="card-title me-2 mr-4">{{titulo}}</h5>
                <div class="ms-auto">
                    <!---------- k ---------->
                <div class="toolbar button-items text-end" v-if="series_x.includes('Enero')">
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('all')"
                    :class="{ active: selection === 'all' }">
                    ALL
                    </button>
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('three_month')"
                    :class="{ active: selection === 'three_month' }">
                    3M
                    </button>
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('six_months')"
                    :class="{ active: selection === 'six_months' }">
                    6M
                    </button>
                    <button type="button" class="btn btn-light btn-sm" @click="updateData('one_year')"
                    :class="{ active: selection === 'one_year' }">
                    1Y
                    </button>
                </div>
                <!---------- k ---------->
                <div class="toolbar button-items text-end" v-if="!series_x.includes('Enero')">
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('all')"
                    :class="{ active: selection === 'all' }">
                    ALL
                    </button>
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('three_year')"
                    :class="{ active: selection === 'three_year' }">
                    3Y
                    </button>
                    <button type="button" class="btn btn-light me-1 btn-sm" @click="updateData('six_year')"
                    :class="{ active: selection === 'six_year' }">
                    6Y
                    </button>
                    <button type="button" class="btn btn-light btn-sm" @click="updateData('one_year')"
                    :class="{ active: selection === 'one_year' }">
                    1Y
                    </button>
                </div>
                </div>
            </div>

            <div class="row text-center">
                <div class="col-lg-4">
                <div class="mt-4">
                    <p class="text-muted mb-1">Este Mes</p>
                    <h5>{{ formatNumber(este_mes[este_mes.length-1]) }}</h5>
                </div>
                </div>

                <div class="col-lg-4">
                <div class="mt-4">
                    <p class="text-muted mb-1">Este año</p>
                    <h5>
                        <h4>{{ formatNumber(este_año[este_año.length-1]) }}
                        </h4>
                    </h5>
                </div>
                </div>

                <div class="col-lg-4">
                <div class="mt-4">
                    <p class="text-muted mb-1">Mes anterior</p>
                    <h5>
                    {{ formatNumber(totalVentasMesAnterior) }}
                    </h5>
                </div>
                </div>
            </div>

            <hr class="mb-4" />

            <apexchart  ref="chart" class="apex-charts" dir="ltr" height="350" max-width="100%" :series="chartData.series"
                :options="chartData.chartoptions"></apexchart>
            </div>
        </div>
</template>

